<!--
  @description 业务上线申请单
  @author xiehan
  @date 2019/01/14
-->
<template>
  <div class="shutdownRequest">
    <request-note
      ref="requestNote"
      @submitRequest="getRequestForm"
      submitButtonRac="shutdownRequest@submit"
      :requestTitle="$t('cloudApplication.shutdownRequest')"
      :disAgreeInfo="disAgreeInfo"
      :status="status">
      <div slot="center">
        <el-row :gutter="10" style="margin-bottom: 10px;">
          <el-col :span="8">
            <div v-text="'IP'" class="shutdown-title"></div>
          </el-col>
          <el-col :span="4">
            <el-button icon="icon-xinzeng"
              type="primary"
              style="width: 70px;"
              @click="addIP"></el-button>
          </el-col>
        </el-row>
        <el-form ref="shutdownForm" :model="shutdownForm" label-width="0">
          <el-row :gutter="10" v-for="(item, index) in shutdownForm.shutdownList" :key="item.itemKey">
            <el-col :span="8">
              <el-form-item>
                <el-select v-model="item.ip" filterable>
                  <el-option
                    v-for="item in select_ip"
                    :key="item"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button icon="icon-shanchu1"
                style="width: 70px;"
                @click="deleteIP(index)"></el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-table
          v-if="status === '5'"
          :data="processTable"
          style="width: 100%">
          <el-table-column prop="operateTime" :label="$t('common.time')"></el-table-column>
          <el-table-column prop="node" :label="$t('queryworkOrder.node')"></el-table-column>
          <el-table-column prop="operator" :label="$t('queryworkOrder.operator')"></el-table-column>
          <el-table-column prop="operation" :label="$t('common.handle')"></el-table-column>
          <el-table-column prop="advise" :label="$t('queryworkOrder.advise')"></el-table-column>
        </el-table>
      </div>
    </request-note>
  </div>
</template>

<script>
  import dic from '@/components/mixins/dic'
  import requestNote from '@/views/component/requestNote/requestNote'
  import queryworkOrderBiz from '@/logic/workFlow/queryworkOrderBiz'
  import resApplicationBiz from '@/logic/workFlow/resApplicationBiz'
  import cmdbBiz from '@/logic/cmdb/cmdbBiz'
  import TimeFormat from '@/utils/timeFormat'
  export default {
    mixins: [dic],
    data () {
      return {
        select_ip: {},
        select_operate: {},
        shutdownForm: {
          shutdownList: [{
            ip: 1,
            itemKey: new Date().getTime()
          }]
        },
        status: '1',
        disAgreeInfo: {},
        processTable: []
      }
    },
    components: {
      requestNote
    },
    methods: {
      async getDic () {
        await Promise.all([
          this.dGetDictionaryByCode('workflowOperationType')
        ])
        if (this.$route.query.status === '5') {
          this.getOrderInfo()
        }
        this.select_operate = { ...this.dDictionary.workflowOperationType }
      },
      getIPList () {
        cmdbBiz.hostList({ perPageCount: 99999, status: 4 }).then((data) => {
          let ipObj = {}
          if (data && data.dataList && data.dataList.length > 0) {
            data.dataList.map(item => {
              ipObj[item.ip1] = item.ip1
            })
          }
          this.select_ip = ipObj
          this.shutdownForm.shutdownList[0].ip = Object.keys(this.select_ip)[0]
        })
      },
      getRequestForm (val) {
        this.$refs['shutdownForm'].validate((valid) => {
          if (valid) {
            let ipList = []
            this.shutdownForm.shutdownList.map(item => {
              ipList.push(item.ip)
            })
            let saveInfo = {
              applicant: val.applicant,
              approver: val.approver,
              cc: val.cc,
              department: val.department,
              expectedTime: val.expectedTime,
              ipList: ipList,
              orderType: val.orderType,
              templateId: val.orderType,
              processInstanceId: val.processInstanceId,
              reason: val.reason,
              remarks: val.remarks,
              site: val.site
            }
            resApplicationBiz.submitShutdownApply(saveInfo).then(() => {
              this.$message({
                message: this.$t('common.success'),
                type: 'success'
              })
              this.$router.push({ name: 'cloudApplication' })
            })
          } else {
            return false
          }
        })
      },
      addIP () {
        this.shutdownForm.shutdownList.push({
          ip: Object.keys(this.select_ip)[0],
          itemKey: new Date().getTime()
        })
      },
      deleteIP (index) {
        if (this.shutdownForm.shutdownList.length === 1) return
        this.shutdownForm.shutdownList.splice(index, 1)
      },
      getOrderInfo () {
        queryworkOrderBiz.getTaskDetailById({
          processInstanceId: String(this.$route.query.orderId)
        }).then(data => {
          this.disAgreeInfo = data
          this.processTable = data.record
          this.processTable.map(item => {
            item.operateTime = TimeFormat.getFormatTime(item.operateTime)
            item.operation = this.select_operate[item.operation]
          })
          this.shutdownForm.shutdownList = []
          this.disAgreeInfo.info.ipList.map((item, index) => {
            this.shutdownForm.shutdownList.push({
              ip: item,
              itemKey: index
            })
          })
          this.$nextTick(() => {
            this.$refs.requestNote.onStatus5()
          })
        })
      }
    },
    watch: {
      $route (to, from) {
        if (to.name === 'shutdownRequest' && from.name === 'cloudApplication') {
          this.status = '1'
          this.$nextTick(() => {
            this.$refs.requestNote.init()
          })
          this.shutdownForm.shutdownList = [{
            ip: Object.keys(this.select_ip)[0],
            itemKey: new Date().getTime()
          }]
          this.getDic()
        } else if (to.name === 'shutdownRequest' && from.name === 'queryworkOrder') {
          this.status = '5'
          this.getDic()
        }
      }
    },
    mounted () {
      if (this.$route.query.status === '5') {
        this.status = '5'
      }
      this.getDic()
      this.getIPList()
    }
  }
</script>

<style scoped>
 .shutdown-title {
    height: 33px;
    line-height: 33px;
    display: inline-block;
  }
</style>